export default "__VITE_PUBLIC_ASSET__6ff2dd24__"